module.exports = __webpack_public_path__ + "static/media/arena-map.048511ab.png";